import { Typo3SectionSpotSanityContentText } from '@/types/typo3'
import { Button } from '@/ui/components'
import { memo } from 'react'

interface Props {
  data: Typo3SectionSpotSanityContentText['content']['tips']
}

const Tips = ({ data }: Props) => (
  <div className={'gap-lg grid grid-cols-1 justify-start'}>
    {data?.map((tip) => (
      <div
        key={tip?.uid}
        className={
          'row-gap-md p-lg grid grid-cols-1 justify-items-start border border-neutral-300'
        }
      >
        <span className="font-bold">{tip?.title}</span>
        <p>{tip?.summary}</p>
        <Button
          variant="secondary"
          icon={tip?.button?.icon !== '' ? tip?.button?.icon : undefined}
          href={tip?.button?.link?.href}
          nextLink={tip?.button?.link?.target === '' ? true : false}
          target={
            tip?.button?.link?.target === ''
              ? undefined
              : (tip?.button?.link?.target as string)
          }
        >
          {tip?.button?.label}
        </Button>
      </div>
    ))}
  </div>
)
export default memo(Tips)
